import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

function normalizeLegacyHashUrl(): void {
  const hash = window.location.hash;
  if (!hash.startsWith('#/')) {
    return;
  }

  const cleanPath = hash.slice(1);
  const targetUrl = `${cleanPath}${window.location.search}`;
  window.history.replaceState(null, '', targetUrl);
}

if (environment.production) {
  enableProdMode();
}

normalizeLegacyHashUrl();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
